import { useSocketsStore } from '@/stores/sockets';
import { useSystemAudioMicrophoneStore } from '@/stores/systemAudioMicrophone';

export default function useSystemMicControl() {
  const socketsStore = useSocketsStore();
  const systemMicrophoneStore = useSystemAudioMicrophoneStore();

  const startMic = async () => {
    if (!systemMicrophoneStore.isMicOn) {
      socketsStore.sendMessageAudioStreamStart(systemMicrophoneStore.socketId);
      systemMicrophoneStore.initMicEvent(sendAudioChunk);
      await systemMicrophoneStore.startMic();
    }
  };

  const stopMic = async () => {
    if (systemMicrophoneStore.isMicOn) {
      socketsStore.sendMessageAudioStreamEnd(systemMicrophoneStore.socketId);
      await systemMicrophoneStore.stopMic();
    }
  };

  const sendAudioChunk = (data) => {
    const audioBytes = new Float32Array(data);
    socketsStore.sendMessageAudioStreamChunk(systemMicrophoneStore.socketId, new Uint8Array(audioBytes.buffer), 'as');
  };

  return {
    sendAudioChunk,
    startMic,
    stopMic,
  };
}
